import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Say `}<a parentName="p" {...{
        "href": "mailto:ayushsatyam30@gmail.com"
      }}>{`Hi`}</a>{` or find me on other platforms: `}<a parentName="p" {...{
        "href": "https://facebook.com/ayushrockzzz"
      }}>{`facebook`}</a>{` | `}<a parentName="p" {...{
        "href": "https://Instagram.com/ayushrockzzz"
      }}>{`Instagram`}</a>{` | `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/ayushrockzzz/"
      }}>{`Linkedin`}</a>{` | `}<a parentName="p" {...{
        "href": "https://Github.com/ayushrockzzz"
      }}>{`Github`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      